import i18n from '@/locales'
import type { Sprachtext } from '@/types/api'

/**
 * Ein Text aus dem Bausteinkatalog in der Sprache des Panels.
 *
 * Die Namen und Beschriftungen der Bausteine kommen aus dem Kundenrepo, nicht
 * aus den Sprachdateien des Panels: Ein Baustein wird dort beschrieben, wo er
 * gebaut wird. Deutsch ist Pflicht und der Rückfall.
 */
export function sprachtext(text: Sprachtext | undefined | null): string {
  if (!text) return ''
  // Wie in useSprache.ts: vue-i18n typt `locale` falsch, zur Laufzeit ist es ein Ref.
  const sprache = (i18n.global.locale as unknown as { value: string }).value
  return text[sprache] ?? text.de ?? Object.values(text)[0] ?? ''
}
